module.exports = () => {
  return {
    app_name: 'ByCS Portal',
    styles: {
      load: () => import(/* webpackChunkName: "styleBYCS" */'src/config/brandings/bycs/index.scss')
    },
    meta: {
      meta: [
        { name: 'og:image', content: '/brandings/bycs/favicons/favicon-192x192.png' },
        { name: 'twitter:image', content: '/brandings/bycs/favicons/favicon-192x192.png' }
      ],
      link: [
        { rel: 'shortcut icon', href: '/brandings/bycs/favicons/favicon-32x32.png', type: 'image/png' }
      ]
    },
    logos: {
      logo: 'brandings/bycs/logo/bycs-logo.svg'
    },
    search: {
      queries: {
        branding: null
      }
    },
    start: {
      description: 'public.start.security',
      image: false,
      show_more: false,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: false
    },
    onboarding: {
      help_videos: false
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: true,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    }
  }
}
